import {Component, Input, OnInit} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {CandidateDetailsComponent} from "../../agency-candidates/candidate-details-dialog/candidate-details.component";
import {EtbDetailsComponent} from "../etb-details-dialog/etb-details.component";
import { MessageDialogComponent } from '../../../../shared/components/message-dialog/message-dialog.component';
import { MaterialModule } from '../../../../material/material.module';

@Component({
  selector: 'app-agency-more-detail-action-for-candidate',
  standalone: true,
  imports: [MaterialModule],
  templateUrl: './agency-more-detail-action-for-etb.component.html',
  styleUrl: './agency-more-detail-action-for-etb.component.scss'
})
export class AgencyMoreDetailActionForEtbComponent implements OnInit{
  @Input() data: any = undefined;
  @Input() column: any = undefined;

  constructor(private dialog: MatDialog) {
  }

  ngOnInit(): void {
  }

  openDetailCandidate = () => {
    this.dialog.open(EtbDetailsComponent, {
      width: '666px',
      height: '100vh',
      position: {right: '0'},
      backdropClass: 'bg-transparent',
      data: {
        etb: {etbId: this.data.id}
      },
    });
  };

}
